import { render, staticRenderFns } from "./talent_acquisition.vue?vue&type=template&id=29219064&scoped=true"
import script from "./talent_acquisition.vue?vue&type=script&lang=js"
export * from "./talent_acquisition.vue?vue&type=script&lang=js"
import style0 from "./talent_acquisition.vue?vue&type=style&index=0&id=29219064&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29219064",
  null
  
)

export default component.exports